import apiV2 from './apiV2';

export const dailyChecklistApi = {
  context: (section?: number) => apiV2.get('/goals/my/checklist/', { params: section ? { section_id: section } : {} }).then(r => r.data),
  createChoice: (data: Record<string, unknown>) => apiV2.post('/goals/my/work-choices/', data).then(r => r.data),
  start: (data: Record<string, unknown>) => apiV2.post('/goals/my/check-in/', data).then(r => r.data),
  finish: (data: Record<string, unknown>) => apiV2.post('/goals/my/check-out/', data).then(r => r.data),
};

export function workKey(plan: any): string {
  return plan?.work_choice_id ? `work:${plan.work_choice_id}` : plan?.project_goal_id ? `goal:${plan.project_goal_id}` : '';
}

export function safeWorkUrl(value: string): string | undefined {
  try { const url = new URL(value); return ['https:', 'http:'].includes(url.protocol) ? url.href : undefined; } catch { return undefined; }
}

export function checklistError(error: any): string {
  const data = error?.response?.data;
  const messages = (value: unknown): string[] => {
    if (typeof value === 'string') return [value];
    if (Array.isArray(value)) return value.flatMap(messages);
    if (value && typeof value === 'object') return Object.values(value).flatMap(messages);
    return [];
  };
  return messages(data?.detail || data?.error || data).join(' ') || 'Could not save. Your entries are still here. Try again.';
}
